import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
interface LoaderProps {
    openLoader: boolean
    setOpenLoader: (open:boolean)=>void
}
const Loader = ({openLoader, setOpenLoader}:LoaderProps) => {
  return (
    <div>
        <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={openLoader}
        >
        <CircularProgress color="inherit" />
        </Backdrop>
    </div>
  )
}

export default Loader